
export const getWorkflowsWithManualTrigger = (state) => {
    return state.workflowsWithManualTrigger;
};

export const getWorkflowsEnabledForPost = (state) => {
    return state.workflowsEnabledForPost;
}
